import "./TrackAppointment.css";
import Header from "../Shared/Header/Header";
import Footer from "../Shared/Footer/Footer";

const TrackAppointment = () => {
  return (
    <>
      <Header />
      <Footer />
    </>
  );
};

export default TrackAppointment;